// extracted by mini-css-extract-plugin
export default {"otherPlayer":"OtherPlayer_otherPlayer__TZiCU","hand":"OtherPlayer_hand__ORXVD","info":"OtherPlayer_info__GI3CG","active":"OtherPlayer_active__FInCD"};